import { IRepairStepView, IRepairView } from 'src/providers/repairs/types';

export const stepUrls = (repairDetails: IRepairView, step: IRepairStepView) => {
  const flattenedSteps = repairDetails.sections.map((section) => section.steps).flat();
  const currentStepIndex = flattenedSteps.findIndex((s) => s.url === step.url);
  const nextStep = flattenedSteps[currentStepIndex + 1];
  const prevStep = flattenedSteps[currentStepIndex - 1];
  return {
    prevStepUrl: prevStep?.url,
    nextStepUrl: nextStep?.url,
  };
};
